import type { Route } from './+types/economic-growth';
import type { ResourceItem } from '@/components/sections/resource-list';
import { CtaBanner } from '@/components/sections/cta-banner';
import { HeroSection } from '@/components/sections/hero-section';
import { ResourceListSection } from '@/components/sections/resource-list';
import { inheritRootLdJson } from '@/utils/schema';

const ECONOMIC_MARKERS: Array<ResourceItem> = [
  {
    id: 'leading-industrial-output',
    title: 'Leading Industrial Output',
    href: 'https://www.remplan.com.au',
    hrefLabel: 'remplan.com.au',
    description:
      'The energy, utilities, and resource segment remains the largest individual driver for the regional economy, tracking output over $750 million.',
  },
  {
    id: 'council-financial-position',
    title: 'Council Financial Position',
    href: 'https://www.southburnett.qld.gov.au',
    hrefLabel: 'southburnett.qld.gov.au',
    description:
      'The annual budget carries a planned, non-cash infrastructure depreciation operational deficit of $3.5 million to maintain steady service delivery.',
  },
  {
    id: 'state-planning-collaboration-dwelling-supply',
    title: 'State Planning Collaboration and Dwelling Supply Targets',
    href: 'https://statements.qld.gov.au',
    hrefLabel: 'statements.qld.gov.au',
    description:
      'New planning policies aim to deliver up to 49,000 new residential spaces across the wider zone by 2046 to support population growth.',
  },
];

export function meta({ matches }: Route.MetaArgs) {
  return [
    ...inheritRootLdJson(matches),
    { title: 'Key Economic Markers | Kingaroy & South Burnett | Meet Real Estate' },
    {
      name: 'description',
      content:
        'The key economic markers shaping Kingaroy and the South Burnett — from leading industrial output to council finances and state dwelling supply targets.',
    },
  ];
}

export default function EconomicGrowth() {
  return (
    <main>
      <HeroSection
        eyebrow="Economic Growth"
        heading="Key Economic Markers"
        description="The figures and forward plans shaping the South Burnett economy — worth knowing about whether you're buying, selling, or simply keeping an eye on the region's outlook."
        primaryCta={{ label: 'Get in Touch', to: '#contact' }}
      />

      <ResourceListSection
        id="markers"
        className="scroll-mt-20"
        eyebrow="The Numbers"
        heading="Key Economic Markers"
        resources={ECONOMIC_MARKERS}
      />

      <CtaBanner
        id="contact"
        className="section--navy-mid scroll-mt-20"
        heading="Wondering How the Regional Economy Could Affect Your Property?"
        description="Whether you're buying, selling, or just curious about the region's outlook, a confidential conversation costs you nothing."
        primaryCta={{ label: 'Request an appraisal', to: '/appraisal' }}
        secondaryCta={{ label: 'Call Lucio', to: 'tel:0493035628' }}
        contactName="Lucio Passos"
        contactTitle="Sales Agent, Meet Real Estate"
        contactLinks={[
          { label: 'Mobile', value: '0493 035 628', href: 'tel:0493035628' },
          { label: 'Office', value: '07 3355 7777', href: 'tel:0733557777' },
          { label: 'Email', value: 'lucio@meetrealestate.com.au', href: 'mailto:lucio@meetrealestate.com.au' },
          { label: 'Website', value: 'meetrealestate.com.au', href: 'https://meetrealestate.com.au' },
        ]}
      />
    </main>
  );
}
